// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2SlQz","box":"WorkspacesBox_box__1oBaW","node":"WorkspacesBox_node__voT5Q"};